import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { AsignaturasRelacionadasDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class AsignaturasRelacionadasService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getAsignaturasRelacionadasService(): Observable<BodyListResponse<AsignaturasRelacionadasDTO>> {
    return this.http.get<BodyListResponse<AsignaturasRelacionadasDTO>>(API_URL + '/api/v1/asignaturasRelacionadas/todos');
  }

  getAsignaturasRelacionadasPorSolicitudService(codigo: string): Observable<BodyListResponse<AsignaturasRelacionadasDTO>> {
    return this.http.get<BodyListResponse<AsignaturasRelacionadasDTO>>(API_URL + '/api/v1/asignaturasRelacionadas/solicitud/' + codigo);
  }

  guardarAsignaturasRelacionadasService(asignaturasRelacionadasDTO: AsignaturasRelacionadasDTO): Observable<BodyResponse<AsignaturasRelacionadasDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/asignaturasRelacionadas', asignaturasRelacionadasDTO);
  }

  guardarAsignaturasRelacionadasListaService(asignaturasRelacionadasDTO: Array<AsignaturasRelacionadasDTO>): Observable<BodyResponse<AsignaturasRelacionadasDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/asignaturasRelacionadas/guardarLista', new BodyListResponse(asignaturasRelacionadasDTO, asignaturasRelacionadasDTO.length));
  }



  getAsignaturasRelacionadasPorCodigoService(codigo: string): Observable<BodyResponse<AsignaturasRelacionadasDTO>> {
    return this.http.get<BodyResponse<AsignaturasRelacionadasDTO>>(API_URL + '/api/v1/asignaturasRelacionadas/' + codigo);
  }
}
